import React from 'react';
import { CohortAuditLog } from 'types';

type ComponentProps = {
  item: CohortAuditLog;
};

const auditLogTypeMap = {
  membership_add: 'Assigned',
  membership_remove: 'Removed',
};

const NestedListItem: React.FC<ComponentProps> = ({ item }) => {
  const getType = (): string => {
    if (item.uuid.includes('insight')) {
      return 'Insight';
    }
    if (item.uuid.includes('prevent')) {
      return 'Prevent';
    }
    return '-';
  };

  return (
    <tr className="row-hover table-row border-t border-gray-200 align-middle bg-litlingo-gray-0.5 bg-opacity-50 text-body">
      <td className="table-wrapper__new-td">
        <div className="h-auto m-0 p-0 flex text-body">
          <div className="py-2 pl-9">
            <span>{auditLogTypeMap[item.type as keyof typeof auditLogTypeMap]}</span>
          </div>
        </div>
      </td>

      <td className="table-wrapper__new-td">
        <div className="h-auto m-0 p-0 flex text-body">
          <span>{getType()}</span>
        </div>
      </td>

      <td className="table-wrapper__new-td">
        <div className="h-auto pr-4 flex items-center">
          <div className="text-left text-body clamped-text-2 overflow-hidden">
            <span>{item.payload.user_uuid}</span>
          </div>
        </div>
      </td>

      <td className="table-wrapper__new-td">
        <div className="h-auto m-0 p-0 flex text-body">
          <span>{item.payload.user_uuid}</span>
        </div>
      </td>
    </tr>
  );
};

export default NestedListItem;
